import Icons from '@/constants/Icons';
import AppAction from '@/models/core/AppAction';
import { useSessionStore } from '@/stores/session';

export const groupAction = (name: string, children: AppAction[]) => new AppAction({ name }, children);

export const logoutAction = () =>
  new AppAction({
    handler: () => {
      const { logout } = useSessionStore();
      logout();
    },
    icon: Icons.Logout,
    name: 'Logout',
  });

export const pinLoginAction = () =>
  new AppAction({
    handler: () => {
      const { openPinModal } = useSessionStore();
      openPinModal();
    },
    icon: Icons.PinLogin,
    name: 'PinLoginModal',
  });
